import React from "react";
import AddressCard from "./AddressCard/AddressCard";
import AddressPopup from "./AddressPopup/AddressPopup";
import { Translation } from 'react-i18next';
import i18n from "../../../i18n"
import { addressesService } from "./Service"
import toaster from "../../../utils/toaster"
import { ReactComponent as AddIcon } from "../../../images/Add.svg"

import "./profile-addresses.styles.scss"

export default class ProfileAddresses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addresses: [],
        };
    }

    componentDidMount() {
        addressesService.getAddresses()
            .then(response => {
                console.log(response);
                this.setState({
                    addresses: response.data,
                })
            }).catch((error) => {
                console.log(error);
            })
    }

    newAddress = (address) => {
        addressesService.newAddress(address)
            .then(response => {
                console.log(response);
                this.setState({
                    addresses: response.data,
                })
                if (address.id) {
                    toaster.standard(i18n.t("addresses.update-message"))
                } else {
                    toaster.standard(i18n.t("addresses.new-message"))
                }
            }).catch((error) => {
                console.log(error);
            })
    }

    deleteAddress = (addressId) => {
        addressesService.deleteAddress(addressId)
            .then(response => {
                console.log(response);
                this.setState({
                    addresses: response.data,
                })
                toaster.standard(i18n.t("addresses.delete-message"))
            }).catch((error) => {
                console.log(error);
            })
    }

    render() {
        const { addresses } = this.state;
        return (
            <Translation>
                {t =>
                    <div className="profile-addresses">
                        <div className="profile-addresses-section">{t("addresses.pageTitle")}</div>
                        <AddressPopup
                            action={this.newAddress}
                            title={t("addresses.new")}
                            button={t("save")}
                            isUpdate={false}
                            trigger={
                                <button className="add outline">
                                    <AddIcon className="icon" />
                                    <span className="text">{t("addresses.addButton")}</span>
                                </button>
                            }
                        />
                        <hr />
                        <div className="profile-addresses-title">{t("addresses.title")}</div>
                        {addresses && addresses.map((address, index) => (
                            <AddressCard
                                key={address.id}
                                address={address}
                                index={index}
                                action={this.newAddress}
                                deleteAddress={this.deleteAddress}
                            />
                        ))}
                    </div>
                }
            </Translation>
        );
    }
}

